// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";

// import getBoldededText from "@insite/client-framework/Common/Utilities/getPatternBolded"; bunzl remove code

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/ClearProduct";
import reset from "@insite/client-framework/Store/Components/ProductSelector/Handlers/Reset";
import searchProducts from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import setProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import setUnitOfMeasure from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetUnitOfMeasure";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import debounce from "lodash/debounce"; Bunzl remove code
import React, { ChangeEvent, ReactNode, useCallback, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Starter Custom Code

import { useDebounce } from "@store/Framework/Common/Hooks/useDebounce";
import {
    StoreMultipleSalesMessage,
    StoreMultipleSalesMessageStyle,
} from "@store/Library/Components/Foundation/StoreProduct/StoreProductMultipleSales";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

interface OwnProps {
    onSelectProduct: (productInfo: ProductInfo, product: ProductModel) => void;
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
    selectButtonTitle?: string;
    productIsConfigurableMessage?: ReactNode;
    productIsUnavailableMessage?: ReactNode;
    customErrorMessage?: ReactNode;
    extendedStyles?: ProductSelectorStyles;
    // Store Custom Code
    customLabel?: string;
    customPlaceholder?: string;
    oneClick?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const { isSearching, searchResults, selectedProductInfo, errorType } = getProductSelector(state);
    const product = getProductState(state, selectedProductInfo?.productId).value;
    return {
        isSearching,
        searchResults,
        selectedProductInfo,
        product,
        errorType,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    searchProducts,
    setProduct,
    clearProduct,
    setUnitOfMeasure,
    reset,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductSelectorStyles {
    container?: GridContainerProps;
    searchGridItem?: GridItemProps;
    qtyGridItem?: GridItemProps;
    unitOfMeasureGridItem?: GridItemProps;
    buttonGridItem?: GridItemProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    qtyTextField?: TextFieldPresentationProps;
    optionWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    productImage?: LazyImageProps;
    infoWrapper?: InjectableCss;
    autocompleteTitleText?: TypographyPresentationProps;
    autocompleteErpText?: TypographyPresentationProps;
    selectButton?: ButtonPresentationProps;
    searchDynamicDropdown?: DynamicDropdownPresentationProps;
    clearIcon?: IconProps;
    // Starter Custom Code
    multipleSaleQtyMessage?: StoreMultipleSalesMessageStyle;
}

export const productSelectorStyles: ProductSelectorStyles = {
    container: {
        gap: 10,
    },
    searchGridItem: {
        width: [12, 12, 4, 5, 5],
        css: css`
            position: relative;
        `,
    },
    qtyGridItem: {
        width: [3, 3, 2, 1, 1],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    unitOfMeasureGridItem: {
        width: [9, 9, 3, 3, 3],
    },
    optionWrapper: {
        css: css`
            display: flex;
            cursor: pointer;
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            width: ${pxToRem(50)};
            height: ${pxToRem(50)};
            margin-right: ${pxToRem(10)};
        `,
    },
    productImage: {
        width: "50px",
        css: css`
            flex-shrink: 0;
            img {
                height: 100%;
            }
        `,
    },
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    autocompleteTitleText: {
        size: 14,
    },
    autocompleteErpText: {
        size: 14,
        css: css`
            margin-top: ${pxToRem(5)};
        `,
    },
    selectButton: {
        variant: "primary",
        css: css`
            ${x => x.theme.button.primary.css}
            margin-top: ${pxToRem(30)};

            ${breakpoint("sm", "down")} {
                width: 100%;
            }
        `,
    },
    buttonGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            justify-content: flex-end;
        `,
    },
    searchDynamicDropdown: {
        cssOverrides: {
            selectedText: css`
                text-overflow: ellipsis;
                padding-right: 2em !important;
                max-width: 95%;
            `,
        },
        spinnerProps: {
            color: "primary",
            size: 42,
        },
    },
    multipleSaleQtyMessage: {
        message: {
            css: css`
                white-space: nowrap;
                font-size: ${({ theme }) => theme.design.typography.size.tiny};
            `,
        },
    },
    /* Store Custom Code - Start */
    clearIcon: {
        size: 22,
        css: css`
            position: absolute;
            right: 41px;
            top: 46px;
            cursor: pointer;
        `,
    },
    /* Store Custom Code - End */
};

const ENTER_KEY = 13;

const ProductSelector = ({
    onSelectProduct,
    skipInventoryValidation,
    denyFixedConfiguration,
    selectButtonTitle,
    searchProducts,
    isSearching,
    searchResults,
    setProduct,
    clearProduct,
    setUnitOfMeasure,
    selectedProductInfo,
    product,
    errorType,
    extendedStyles,
    customErrorMessage,
    productIsConfigurableMessage,
    productIsUnavailableMessage,
    location,
    reset,
    // Store Custom Code
    customLabel,
    customPlaceholder,
    oneClick,
}: Props) => {
    const [qty, setQty] = useState("1");
    const [multipleSaleQty, setMultipleSaleQty] = useState(Number(qty));
    const [errorMessage, setErrorMessage] = useState<ReactNode>("");
    const [options, setOptions] = useState<OptionObject[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [styles] = useState(() => mergeToNew(productSelectorStyles, extendedStyles));
    useEffect(() => {
        reset();
        // Store Custom Code - effect doesn't fire on unmount and we need to reset the state as mylistsfilters is using it
        return () => {
            reset();
        };
    }, [location.pathname]);

    useEffect(() => {
        /* Store Custom Code - Start */
        if (!searchResults || (!searchResults?.length && !searchTerm)) {
            return;
        }
        /* Store Custom Code - End */

        const newOptions = searchResults.map(product => ({
            optionText: product.title,
            optionValue: product.id || undefined,
            rowChildren: (
                <StyledWrapper {...styles.optionWrapper} data-test-selector={`productSelector_search_${product.id}`}>
                    <StyledWrapper {...styles.imageWrapper}>
                        <LazyImage {...styles.productImage} src={product.image} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.infoWrapper}>
                        <Typography {...styles.autocompleteTitleText}>
                            {/* Store Custom Code */}
                            {product.displayTitle ?? product.title}
                        </Typography>
                        <Typography {...styles.autocompleteErpText}>
                            {/* Store Custom Code */}
                            {product.displayErpNumber ?? product.erpNumber}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            ),
        }));
        setOptions(newOptions);
    }, [searchResults]);

    useEffect(() => {
        setErrorMessage(customErrorMessage);
    }, [customErrorMessage]);

    // bunzl deleted code - moved effect into handler

    useEffect(() => {
        switch (errorType) {
            case "productIsConfigurable":
                setErrorMessage(productIsConfigurableMessage || translate("Cannot select configurable products"));
                break;
            case "productIsUnavailable":
                setErrorMessage(productIsUnavailableMessage || translate("Product is unavailable"));
                break;
            default:
                setErrorMessage("");
                break;
        }
    }, [errorType]);

    const onSelectionChangeHandler = (value?: string) => {
        if (searchResults && searchResults.length > 0) {
            const variantParentId = searchResults.find(o => o.id === value)?.styleParentId;
            // Store Custom Code - move out of effect into handler
            if (variantParentId) {
                setProduct({
                    productId: variantParentId,
                    variantId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                });
            } else {
                setProduct({
                    productId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                    // Store Custom Code - oneClick
                    onComplete: oneClick
                        ? props => {
                              if (props.productInfo && props.product && !props.product.isVariantParent) {
                                  onSelectProduct(props.productInfo, props.product);
                                  clearProduct();
                                  clearButtonHandler();
                              }
                          }
                        : undefined,
                });
            }
        }
    };

    // Store Custom Code - oneClick variant product selection --->
    useEffect(() => {
        if (!oneClick || product?.isVariantParent) {
            return;
        }

        if (selectedProductInfo && product) {
            onSelectProduct(selectedProductInfo, product);
            clearProduct();
            setQty("1");
            searchProducts({ query: "" });
        }
    }, [selectedProductInfo, product]);
    // <--- bunzl custom code

    const debouncedSearchProducts = useDebounce(searchProducts, 400);

    const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setErrorMessage("");
        setSearchTerm(event.target.value);

        if (selectedProductInfo) {
            clearProduct();
        }

        debouncedSearchProducts({ query: event.target.value });
    };

    const selectProduct = () => {
        if (!selectedProductInfo || errorMessage || !product) {
            return;
        }

        const newProductInfo = { ...selectedProductInfo };
        newProductInfo.qtyOrdered = Math.max(Number(qty) || 1, product.minimumOrderQty || 1);
        onSelectProduct(newProductInfo, product);

        clearProduct();
        setQty("1");
        searchProducts({ query: "" });
    };

    const uomChangeHandler = (unitOfMeasure: string) => {
        if (!selectedProductInfo) {
            return;
        }

        setUnitOfMeasure({ unitOfMeasure });
    };

    const onKeyPress = (event: React.KeyboardEvent) => {
        if (event.charCode === ENTER_KEY) {
            if (selectedProductInfo) {
                selectProduct();
            } else if (searchTerm && (!searchResults || searchResults.length === 0)) {
                setProduct({ searchTerm, skipInventoryValidation, denyFixedConfiguration });
            }
        }
    };

    // Starter Custom Code - >
    useEffect(() => {
        // Store Custom Code - don't run this effect if we're using a one click selector
        if (product && !oneClick) {
            setMultipleSaleQty(product?.detail?.multipleSaleQty || 1);
            if (multipleSaleQty > 1) {
                qtyBlurHandler();
            }
        }
    }, [product]);

    const qtyBlurHandler = () => {
        let value = qty;
        if (multipleSaleQty > 0) {
            value = String(Math.ceil(Number(value) / multipleSaleQty) * multipleSaleQty);
        }
        setQty(value);
    };
    // <-- Starter Custom Code

    const clearButtonHandler = () => {
        clearProduct();
        setQty("1");
        searchProducts({ query: "" });
    };
    // Store Custom Code
    const optionsWithProduct = product ? [{ optionText: product.productTitle, optionValue: product.id }] : options;
    return (
        <GridContainer {...styles.container} data-test-selector="productSelector">
            <GridItem {...styles.searchGridItem}>
                <DynamicDropdown
                    {...styles.searchDynamicDropdown}
                    // Store Custom Code
                    label={customLabel || translate("Search")}
                    onSelectionChange={onSelectionChangeHandler}
                    onInputChange={onInputChanged}
                    onKeyPress={onKeyPress}
                    filterOption={() => true}
                    selected={selectedProductInfo?.productId}
                    isLoading={isSearching}
                    options={optionsWithProduct} // Store Custom Code
                    error={errorMessage}
                    // Store Custom Code
                    placeholder={customPlaceholder || translate("Type to search")}
                    data-test-selector="productSelector_search"
                />
                {selectedProductInfo && (
                    <Icon {...productSelectorStyles.clearIcon} src={X} onClick={clearButtonHandler} />
                )}
            </GridItem>
            {/* Store Custom Code - don't show buttons for one click */}
            {!oneClick && (
                <>
                    <GridItem {...styles.qtyGridItem}>
                        <TextField
                            type="number"
                            defaultValue="1"
                            min="0"
                            label={translate("QTY")}
                            value={qty}
                            onChange={e => {
                                setQty(e.currentTarget.value);
                            }}
                            onBlur={qtyBlurHandler} // Starter Custom Code
                            data-test-selector="productSelector_qty"
                        />
                        {product?.detail && (
                            <StoreMultipleSalesMessage
                                qty={multipleSaleQty}
                                extendedStyles={styles.multipleSaleQtyMessage}
                            />
                        )}
                    </GridItem>

                    <GridItem {...styles.unitOfMeasureGridItem}>
                        {product && selectedProductInfo && (
                            <ProductContext.Provider
                                value={{
                                    product,
                                    productInfo: selectedProductInfo,
                                    onUnitOfMeasureChanged: uomChangeHandler,
                                }}
                            >
                                <ProductUnitOfMeasureSelect
                                    extendedStyles={styles.unitOfMeasureSelect}
                                    data-test-selector="productSelector_uom"
                                />
                            </ProductContext.Provider>
                        )}
                    </GridItem>
                    {/* Store Custom Code */}

                    <GridItem {...styles.buttonGridItem}>
                        <Button
                            {...styles.selectButton}
                            onClick={() => selectProduct()}
                            disabled={!selectedProductInfo || !!errorMessage || Number(qty) < 1}
                            data-test-selector="productSelector_selectProduct"
                        >
                            {selectButtonTitle || translate("Select Product")}
                        </Button>
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelector);
